
const sectionId = document.querySelector('.shopify-section').getAttribute('id').replace('shopify-section-', '');
const searchParams = new URLSearchParams(window.location.search);
const screenName = searchParams.get('screen') || 'Unknown';
const details = document.querySelector('.fresh-screen .details');
const cart_items = document.querySelector('.cart-items');
const cart_item_template = document.getElementById('cart-item-template');
const cart_item_template_free = document.getElementById('cart-item-free-template');

const refresh_interval = parseInt(details.dataset.refreshInterval);
const refresh_timeout = parseInt(details.dataset.refreshTimeout);

let refresh_timer;
let intro_timer;

let timeoutDialogTimer;
const fresh_screen = document.querySelector('.fresh-screen');
const slider = document.querySelector('.page-structure');
const freshScreen = document.querySelector('.fresh-screen');
const timeoutDialog = document.querySelector('.screen-timeout-dialog');
const checkoutBtn = document.querySelector('.cart-qr-details .qr-checkout .btn');
const checkoutDialog = document.querySelector('.screen-checkout-dialog');
const freeItemToAdd = {
    threshold: 40,
    variantId: '44699991277786',
    title: 'Rockfish Cookbook',
    price: 0,
    wasPrice: 2499,
}

let productDetails = document.querySelector('.product-details');
const scrollControls = document.querySelector('.screen-footer');
const cartContents = [];
let isDown = false;
let isMoving = false;
let startX;
let scrollLeft;
let screenWidth = window.innerWidth - 25;
let screenHeight = window.innerHeight - 50;

document.addEventListener('contextmenu', event => event.preventDefault());

function captureEvent(action, item) {
    if (typeof gtag === 'function') {
        gtag('event', action, item);
    }
}

function doesCartContainFreeItem() {
    return cartContents.some(item => item.variantId === freeItemToAdd.variantId);
}
function addFreeItemToCart() {
    if (doesCartContainFreeItem() === false) {
        cartContents.push({
            variantId: freeItemToAdd.variantId,
            title: freeItemToAdd.title,
            price: freeItemToAdd.price,
            wasPrice: freeItemToAdd.wasPrice,
            quantity: 1
        });
    }
}

function removeFreeItemFromCart() {
    if (doesCartContainFreeItem()) {
        cartContents.splice(cartContents.findIndex(item => item.variantId === '44699991277786'), 1);
    }
}

slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
});

freshScreen.addEventListener('mouseup', () => {
    setTimeout(() => {
        isMoving = false;
    }, 100);
    isDown = false;
    slider.classList.remove('active');
});

slider.addEventListener('click', (e) => {
    if (isMoving) return;
    const gridProduct = e.target.closest('.grid-product');
    if (!gridProduct) return;

    resetTimer();

    if (e.target.tagName === 'BUTTON') {
        // Add the item to the cart
        const existingItem = cartContents.find(item => item.variantId === gridProduct.dataset.variantId);
        if (existingItem) {
            if (existingItem.quantityAvailable && existingItem.quantityAvailable > existingItem.quantity) {
                existingItem.quantity++;

                captureEvent('tscreen_add_existing', { screen: screenName, 'title': existingItem.title, 'quantity': existingItem.quantity });
            }

        } else {
            cartContents.push({
                variantId: gridProduct.dataset.variantId,
                title: gridProduct.dataset.title,
                price: gridProduct.dataset.price,
                quantity: 1,
                quantityAvailable: gridProduct.dataset.quantityAvailable,
            });
            captureEvent('tscreen_add_existing', { screen: screenName, 'title': gridProduct.dataset.title, 'quantity': 1 });
        }
        renderCart();

        return;
    }
    document.querySelector('.product-detail.is-active')?.classList.remove('is-active');
    const productDetail = document.querySelector(`.product-detail[data-product-id="${gridProduct.dataset.productId}"]`);
    if (!productDetail) return;

    productDetail.classList.add('is-active');
    productDetails.classList.add('is-active');
    let yPos = e.clientY;
    if (yPos + productDetails.offsetHeight > screenHeight) {
        yPos = screenHeight - productDetails.offsetHeight;
    }
    let xPos = e.clientX;
    if (xPos + productDetails.offsetWidth > screenWidth) {
        xPos = screenWidth - productDetails.offsetWidth;
    }
    productDetails.style.left = `${xPos}px`;
    productDetails.style.top = `${yPos}px`;
    captureEvent('tscreen_details', { screen: screenName, 'title': gridProduct.dataset.title });

});

cart_items.addEventListener('click', (e) => {
    resetTimer();
    const action = e.target?.dataset?.action;
    const cart_item = e.target.closest('.cart-item');
    if (!action || !cart_item) return;

    const variantId = cart_item.dataset.variantId;
    const item = cartContents.find(item => item.variantId === variantId);
    if (action === 'remove') {
        item.quantity = 0;
    } else if (action === 'dec') {
        item.quantity--;
    } else if (action === 'inc') {
        if (item.quantityAvailable && item.quantity < parseInt(item.quantityAvailable)) {
            item.quantity++;
        }
    }
    if (item.quantity === 0) {
        cartContents.splice(cartContents.indexOf(item), 1);
    }

    checkoutDialog.close();
    renderCart();

    captureEvent('tscreen_cart_update', { screen: screenName, 'action': action, item: item.title, 'quantity': item.quantity });
});

checkoutBtn.addEventListener('click', (e) => {

    resetTimer();
    checkoutDialog.show();

    const deliveryDayMessage = document.querySelector('.checkout-delivery-message .delivery-day');
    const collectDayMessage = document.querySelector('.checkout-collect-message .collection-day');

    const deliveryDay = calculateDeliveryDay(new Date());

    deliveryDayMessage.innerText = deliveryDayMessage.innerText.replace('[DayName]', deliveryDay);
    collectDayMessage.innerHTML = collectDayMessage.innerText.replace('[DayName]', deliveryDay);

    document.querySelector(".checkout-delivery-qr .qr-code").innerHTML = '';
    let qrCodeDelivery = new QRCode(document.querySelector(".checkout-delivery-qr .qr-code"), {
        text: 'https://therockfish.co.uk/',

        colorDark: "#1b6427",
        colorLight: "#fffef0",
        correctLevel: QRCode.CorrectLevel.H
    });
    qrCodeDelivery.makeCode(getCartCheckoutURL());

    document.querySelector(".checkout-collect-qr .qr-code").innerHTML = '';
    let qrCodeCollection = new QRCode(document.querySelector(".checkout-collect-qr .qr-code"), {
        text: 'https://therockfish.co.uk/',

        colorDark: "#1b6427",
        colorLight: "#fffef0",
        correctLevel: QRCode.CorrectLevel.H
    });
    qrCodeCollection.makeCode(getCartCheckoutURL(true));
    captureEvent('tscreen_cart_checkout', { screen: screenName, 'action': 'checkout' });

});

document.querySelector('.screen-checkout-dialog .checkout-footer .btn').addEventListener('click', (e) => {
    e.preventDefault();
    resetTimer();
    resetScreen();
});

freshScreen.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    isMoving = true;
    resetTimer();
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    productDetails.classList.remove('is-active');
});

productDetails.querySelector('.close').addEventListener('click', () => {
    resetTimer();
    productDetails.classList.remove('is-active');
});

productDetails.addEventListener('click', (e) => {
    if (e.target.tagName === 'A') {
        e.preventDefault();
    }
});

timeoutDialog.addEventListener('click', (e) => {
    const action = e.target?.dataset?.action;

    if (action == 'resetTimer') {
        resetTimer();
        clearInterval(timeoutDialogTimer);
        timeoutDialog.close();
    }

    if (action === 'showIntroScreen') {
        resetScreen();
        clearInterval(timeoutDialogTimer);
        timeoutDialog.close();
    }
});

if (scrollControls) {
    scrollControls.addEventListener('click', (e) => {
        resetTimer();
        const scrollDirection = e.target.closest('.scroll-icon')?.dataset.direction;
        if (scrollDirection) {
            if (scrollDirection === 'left') {
                slider.scrollLeft -= screenHeight / 3;
            } else {
                slider.scrollLeft += screenHeight / 3;
            }
        }
        e.stopPropagation();
    });
}

function getCartCheckoutURL(isCollectionPickup) {

    if (isCollectionPickup) {
        const collectionVariantId = '55233694368119';
        const properties = btoa(`{"Restaurant": "${screenName}"}`)
        return `https://www.therockfish.co.uk/cart/${collectionVariantId}:1,${cartContents.map(item => `${item.variantId}:${item.quantity}`).join(',')}?discount=SCREEN&attributes[screen]=${screenName}&properties=${properties}`;
    }
    return `https://www.therockfish.co.uk/cart/${cartContents.map(item => `${item.variantId}:${item.quantity}`).join(',')}?discount=SCREEN&attributes[screen]=${screenName}`;

}

function renderCart() {
    if (cartContents.length === 0) {
        details.classList.remove('has-items');
        cart_items.innerHTML = '';

    }
    const cartTotal = (cartContents.reduce((acc, item) => acc + (item.price * item.quantity), 0) / 100);

    if (cartTotal >= freeItemToAdd.threshold) {
        addFreeItemToCart();
    } else {
        removeFreeItemFromCart();
    }

    details.classList.add('has-items');
    if (cartTotal >= 20) {
        details.classList.add('threshold-met');
    } else {
        details.classList.remove('threshold-met');
    }

    document.querySelector('.total-price').innerText = `\u00A3${cartTotal.toFixed(2)}`;
    const cart_items_html = document.createElement('div');

    cartContents.forEach(item => {
        let itemHtml = (item.price == 0) ? cart_item_template_free.innerHTML : cart_item_template.innerHTML;
        itemHtml = itemHtml.replaceAll("[variant-id]", item.variantId)
            .replaceAll("[title]", item.title || "Untitled")
            .replaceAll("[wasPrice]", `\u00A3${(item.wasPrice * item.quantity / 100).toFixed(2)}`) // Format price as pounds
            .replaceAll("[price]", `\u00A3${(item.price * item.quantity / 100).toFixed(2)}`) // Format price as pounds
            .replaceAll("[quantity]", item.quantity)
            .replaceAll("[quantity-available]", item.quantityAvailable);
        if (item.quantity >= item.quantityAvailable) {
            itemHtml = itemHtml.replaceAll('data-action="inc"', 'data-action="inc" disabled');
        }
        cart_items_html.innerHTML += itemHtml;
    });
    cart_items.innerHTML = cart_items_html.innerHTML;
}

function reloadProducts() {
    fetch(`?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(
                responseText,
                'text/html',
            );
            const source = html.querySelector('.fresh-screen .page-structure');
            document.querySelector('.fresh-screen .page-structure').innerHTML = source.innerHTML;

            // Reset the selectors 
            productDetails = document.querySelector('.product-details');
            productDetails.querySelector('.close').addEventListener('click', () => {
                resetTimer();
                productDetails.classList.remove('is-active');
            });
        })
        .catch((e) => {
            console.error(e);
        });
}

function resetTimer() {
    if (refresh_interval > 0) {
        clearTimeout(refresh_timer);
        refresh_timer = setTimeout(() => {
            screenTimeoutDialog();
            captureEvent('tscreen_resettimer', { screen: screenName, 'refresh_interval': refresh_interval });

            // We also need to reload the section to get the latest data, instead of reloading the whole page
            reloadProducts();
        }, refresh_interval * 1000);
    }
}


function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function screenTimeoutDialog() {
    timeoutDialog.showModal()
    timeoutDialog.dataset.currentTimeOut = refresh_timeout || 15;
    timeoutDialog.querySelector('.timer').innerText = timeoutDialog.dataset.currentTimeOut;
    timeoutDialogTimer = setInterval(() => {
        timeoutDialog.dataset.currentTimeOut--;
        timeoutDialog.querySelector('.timer').innerText = timeoutDialog.dataset.currentTimeOut;
        if (timeoutDialog.dataset.currentTimeOut <= 0) {
            clearInterval(timeoutDialogTimer);
            resetScreen();
            timeoutDialog.close();
        }
    }, 1000);
}

function calculateDeliveryDay(currentDate) {
    const timeCutOffForTomorrow = 13;
    const dayOfWeek = currentDate.getDay();
    const currentHour = currentDate.getHours();
    /*
      Sunday 0
      Monday 1
      Tuesday 2
      Wednesday 3
      Thursday 4
      Friday 5
      Saturday 6
    */
    if ((dayOfWeek == 5 && currentHour >= timeCutOffForTomorrow) || dayOfWeek === 6 || dayOfWeek == 0) {
        return "Tuesday";
    }

    const daysToAdd = currentHour < timeCutOffForTomorrow ? 1 : 2;
    const deliveryDay = addDays(currentDate, daysToAdd)
    return deliveryDay.toLocaleDateString('en-UK', { weekday: 'long' });
}

function resetScreen(hasLoaded) {
    const deliveryDayMessage = document.querySelector('.delivery-day');
    deliveryDayMessage.innerText = deliveryDayMessage.innerText.replace('[DayName]', calculateDeliveryDay(new Date()));
    reloadProducts();

    cartContents.length = 0;
    renderCart();
    resetTimer();
    checkoutDialog.close();
    if (hasLoaded) {
        captureEvent('tscreen_loaded', { screen: screenName, 'width': window.innerWidth, 'height': window.innerHeight });
    } else {
        captureEvent('tscreen_cart_reset', { screen: screenName });
    }
}


resetScreen(true);
